import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {WebToAppCtaModuleConfig} from "./web-to-app-cta-module.config";
import {WebToAppCtaModuleState} from "./models/web-to-app-cta-module.state";

export class WebToAppCtaModuleStore extends BaseMobxStore {
  static injectables = [WebToAppCtaModuleConfig, WebToAppCtaModuleState];
}

